import { render, staticRenderFns } from "./MarketQuotations.vue?vue&type=template&id=4c4f7b64&scoped=true&"
import script from "./MarketQuotations.vue?vue&type=script&lang=js&"
export * from "./MarketQuotations.vue?vue&type=script&lang=js&"
import style0 from "./MarketQuotations.vue?vue&type=style&index=0&id=4c4f7b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f7b64",
  null
  
)

export default component.exports